import Typography from '@mui/material/Typography'
import { SvgIcon } from '../../../shared/ui/SvgIcon/SvgIcon'
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons/faCircleCheck'
import Box from '@mui/material/Box'
import { InfoNotice } from '../../../shared/ui/InfoNotice/InfoNotice'
import { useAppSelector } from '../../../shared/lib/hooks/useAppSelector/useAppSelector'
import { selectAppSecretKeyData } from '../model/selectors/selectAppSecretKeyData'
import { AppLink, AppLinkTheme } from '../../../shared/ui/AppLink/AppLink'
import { faCopy } from '@fortawesome/free-solid-svg-icons/faCopy'
import Tooltip from '@mui/material/Tooltip'
import Button from '@mui/material/Button'
import { showToast } from '../../../shared/lib/showToast/showToast'
import { useState } from 'react'

export const ApplicationSecretKey = () => {
	const { secret, applicationId } = useAppSelector(selectAppSecretKeyData)
	const [flag, setFlag] = useState<boolean>(false)

	const handleCopy = () => {
		if (!secret) return
		navigator.clipboard.writeText(secret)
			.then(() => showToast({
				type: 'success',
				toastId: 'copySecretKey',
				message: 'Secret key copied to clipboard'
			}))
			.catch((error) => console.error('Failed to copy secret key:', error))

		setFlag(true)
		setTimeout(() => {
			setFlag(false)
		}, 8000)
	}

	if (!secret || !applicationId) {
		return (
			<Typography>
				No secret key or application ID available
			</Typography>
		)
	}

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				gap: 2,
				alignItems: 'center'
			}}
		>
			<Typography fontSize={'1.25rem'}>
				Application ID is successfully created<SvgIcon
				icon={faCircleCheck}
				styles={{ display: 'inline-block', marginLeft: 2, mb: 4 }} />
			</Typography>
			<Typography>
				Below are the credentials required to access the API:
			</Typography>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					gap: 1
				}}
			>
				<InfoNotice
					content={
						'The secret key is shown only once.\r\n' +
						'Please, save it in a secure place.If it is lost, you will need to reset the key'
					}
					iconLeft={true}
				/>
				<Box>
					<Typography component="span">Secret key:</Typography>
					<Typography
						component="span"
						sx={{ display: 'inline-block', mx: 2, color: '#40A2B5' }}
					>
						{secret ?? 'No secret key provided'}
					</Typography>
					{flag ? (
						<Box component="span" sx={{ display: 'inline-block' }}>
							<SvgIcon icon={faCircleCheck} />
						</Box>
					) : (
						<Tooltip title="Copy key" placement="top">
							<Button
								size="small"
								sx={{
									width: 'fit-content !important',
									minWidth: 'unset',
									p: '0 !important'
								}}
								onClick={handleCopy}>
								<SvgIcon icon={faCopy} />
							</Button>
						</Tooltip>
					)}
				</Box>
				<Box>
					<Typography component="span">Application ID:</Typography>
					<Typography
						component="span"
						sx={{ display: 'inline-block', ml: 1, mb: 1 }}
					>
						{applicationId ?? 'Invalid application id'}
					</Typography>
				</Box>
				{applicationId && (
					<AppLink
						to={`/applications/${applicationId}`}
						theme={AppLinkTheme.AZURE}
					>
						Go to application page
					</AppLink>
				)}
			</Box>
		</Box>
	)
}